// Yes this is under the layouts folder
// Why this has the same code as MainLayout is because
// I may want to change this and have different wrappers
// for different layouts. For now, it is the same
// but i do not want to be importing MainLayout everywhere either.

import BackToAllProjects from "components/common/BackToAllProjects";
import Footer from "components/common/Footer";
import Navbar from "components/common/Navbar";

const FiftyFifty = ({ project }) => {
    // This array overrides the default "technical stuff" and "field of work". 
    // The values you keep in the designations are the text fields that are 
    // to be rendered. UNCOMMENT TO OVERRIDE AND ADD VARIABLE designations
    // AS THE SECOND PARAMETER IN THE FUNCTION renderDesignations
    //
    //const designations = [];

    return (
        <div>
            <Navbar />
            <div style={{ height: '100%' }} className="hidden md:grid grid-cols-12">
                <div className="col-span-6">
                    {/* Left column long content */}
                    {project.assets.map(asset => (
                        <img
                            key={asset.id}
                            src={`${process.env.REACT_APP_ZVB_URL}assets/${asset.file}`}
                            alt={asset.alt_text}
                            className="w-full mb-2"
                        />
                    ))}
                </div>
                <div className="col-span-6">
                    <div className="sticky top-20 px-12">
                        <p className="mt-3 font-semibold text-[3rem] tracking-tighter">{project.name}</p>
                        <div
                            className="wysiwyg-content text-[1.1rem]"
                            dangerouslySetInnerHTML={{ __html: project.additional_description }}
                        />
                    </div>
                </div>
            </div>

            <div style={{ height: '100%' }} className="grid md:hidden grid-cols-12">
                <div className="col-span-12">
                    <div className="top-20 px-4 mb-6">
                        <p className="mt-3 font-semibold text-[3rem] tracking-tighter">{project.name}</p>
                        <p>{project.description}</p>
                    </div>
                </div>
                <div className="col-span-12 px-4">
                    {project.assets.map(asset => (
                        <img
                            key={asset.id}
                            src={`${process.env.REACT_APP_ZVB_URL}assets/${asset.file}`}
                            alt={asset.alt_text}
                            className="w-full mb-2"
                        />
                    ))}
                </div>
                <div className="col-span-12">
                    <div className="px-4 mt-6">
                        <div
                            className="wysiwyg-content text-[1.1rem]"
                            dangerouslySetInnerHTML={{ __html: project.additional_description }}
                        />
                    </div>
                </div>
            </div>

            <BackToAllProjects customStyle="text-center text-[1.7rem] text-pink-400 mt-10" />
            <Footer />
        </div>
    );
};

export default FiftyFifty;